import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaArrowRight,
  FaGraduationCap,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { motion } from "framer-motion";

export default function Footer() {

  const links = [
    { name: "About School", path: "/about" },
    { name: "Admissions", path: "/admission-form" },
    { name: "School Curriculum", path: "/school-curriculum" },
    { name: "Faculty", path: "/faculty" },
    { name: "School Houses", path: "/school-houses" },
    { name: "Feedback", path: "/feedback" },
    { name: "FAQs", path: "/faqs" },
    { name: "Career", path: "/career" },
    { name: "Contact Us", path: "/contact" },
  ];

  const socialLinks = [
    {
      icon: <FaFacebookF />,
      url: "https://facebook.com",
    },
    {
      icon: <FaInstagram />,
      url: "https://instagram.com",
    },
    {
      icon: <FaYoutube />,
      url: "https://youtube.com",
    },
  ];

  return (

    <footer className="bg-[#071d36] text-white">

      <div className="max-w-7xl mx-auto px-6 py-14">

        {/* Header */}

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pb-8 border-b border-white/10">

          <div className="flex items-center gap-4">

            <div className="w-16 h-16 rounded-full border-2 border-[#d4af37] flex items-center justify-center text-[#d4af37] text-3xl">

              <FaGraduationCap />

            </div>

            <div>

              <h2 className="text-2xl md:text-3xl font-bold">

                Cambridge International School

              </h2>

              <div className="w-20 h-[2px] bg-[#d4af37] my-2"></div>

              <p className="text-gray-400 text-sm">

                Nurturing Excellence • Building Future Leaders

              </p>

            </div>

          </div>

          <div className="text-center md:text-right">

            <p className="text-[#d4af37] font-semibold">

              Affiliated & Trusted Education

            </p>

            <p className="text-gray-400 text-sm">

              Quality Learning Environment

            </p>

          </div>

        </div>

        {/* Main */}

        <div className="grid md:grid-cols-3 gap-12 py-10">

          {/* School */}

          <div>

            <h3 className="text-lg font-bold text-[#d4af37] mb-5">

              Our School

            </h3>

            <p className="text-gray-300 text-sm leading-7">

              Cambridge International School focuses on academic
              excellence, values, creativity and overall development
              of every student.

            </p>

            <div className="flex gap-3 mt-6">

              {socialLinks.map((item, i) => (

                <motion.a
                  key={i}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.1 }}
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#d4af37] hover:text-[#071d36] transition duration-300"
                >

                  {item.icon}

                </motion.a>

              ))}

            </div>

          </div>
                    {/* Quick Links */}

          <div>

            <h3 className="text-lg font-bold text-[#d4af37] mb-5">

              Quick Links

            </h3>

            <div className="space-y-3">

              {links.map((item, i) => (

                <Link
                  key={i}
                  to={item.path}
                  className="
                  flex
                  items-center
                  gap-3
                  text-gray-300
                  text-sm
                  hover:text-[#d4af37]
                  transition
                  duration-300
                "
                >

                  <FaArrowRight className="text-xs" />

                  {item.name}

                </Link>

              ))}

            </div>

          </div>

          {/* Contact */}

          <div>

            <h3 className="text-lg font-bold text-[#d4af37] mb-5">

              Get In Touch

            </h3>

            <div className="space-y-5 text-sm text-gray-300">

              <a
                href="tel:+919781300975"
                className="flex gap-4 items-center hover:text-[#d4af37] transition duration-300"
              >

                <FaPhoneAlt className="text-[#d4af37]" />

                +91 97813 00975

              </a>

              <a
                href="mailto:cisnakodar@gmail.com"
                className="flex gap-4 items-center hover:text-[#d4af37] transition duration-300"
              >

                <MdEmail className="text-[#d4af37]" />

                cisnakodar@gmail.com

              </a>

              <div className="flex gap-4">

                <FaMapMarkerAlt className="text-[#d4af37] mt-1 flex-shrink-0" />

                <p>

                  Cambridge International School
                  <br />
                  Nakodar, Punjab
                  <br />
                  India

                </p>

              </div>

            </div>

          </div>

        </div>

        {/* Bottom */}

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-sm text-gray-400">

          <p>

            © 2026{" "}

            <span className="text-[#d4af37] font-semibold">

              Cambridge International School

            </span>

            . All Rights Reserved.

          </p>

          <p>

            Designed for Excellence

          </p>

        </div>

      </div>

    </footer>

  );

}